import { Directive, Input,  OnInit } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { ContactsService } from '../Services/contacts.service';
import { SharedDataService } from '../Services/shared-data/shared-data.service';
import { Observable } from 'rxjs';
import {  map } from 'rxjs/operators';
import { Contact} from '../Models/Contact';

@Directive({
  selector: '[emailUnique]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS, useExisting: EmailUniqueDirective, multi:
      true
  }]
})
export class EmailUniqueDirective implements AsyncValidator, OnInit
 {

  //Recevra l'identifiant de contact pour ne pas remonter d'erreur si l'email = email du contact
  @Input() set emailUnique(value: any) {
  this._emailUnique = value;
  if (this.onChange) {
    this.onChange(); // force la revalidation
  }
}
private _emailUnique: any;

  private msg: string='';
  constructor(
    private sharedDatasSvc:SharedDataService
    ,private contactsSvc: ContactsService) {
   }
  ngOnInit(): void {
    this.sharedDatasSvc.getLabel('Email_deja_associe_a_un_compte',null,null)
    .subscribe(res=>this.msg=res);  
  }

  validate(control: AbstractControl): Promise<ValidationErrors> | Observable<ValidationErrors> {
    return this.contactsSvc.ContactByMail(control.value)
    .pipe(map((contact:Contact)=>{     
      if (contact && contact.Id!=(this.emailUnique||0)) {
        let msg2:string=this.msg
          .replace('&1',contact.Civility.Cod)
          .replace('&2',contact.Firstname)
          .replace('&3',contact.Lastname);
        let error: any = {
          toString : function(){
            return msg2;
          },
          message : msg2,
          contact: contact
        };
        return {'emailUnique': error};
      } else {
        return null;
      }
    }));
  }

private onChange?: () => void;
  registerOnValidatorChange?(fn: () => void): void {
    this.onChange = fn;
  }

}